import gql from "graphql-tag";

export const BrokerageBrProfileUpdate = gql `
  mutation brokerageBrProfileUpdate($input: BrokerageBrProfileUpdateInput!) {
    BrokerageBrProfileUpdate(input: $input) {
      clientMutationId
    }
  }
`;

export const BrokerProfileUpdate = gql `
  mutation brokerProfileUpdate($input: BrokerProfileUpdateInput!) {
    BrokerProfileUpdate(input: $input) {
      clientMutationId
    }
  }
`;

export const AssistantProfileUpdate = gql `
  mutation assistantProfileUpdate($input: AssistantProfileUpdateInput!) {
    AssistantProfileUpdate(input: $input) {
      clientMutationId
    }
  }
`;

export const UpdateCompanyDetail = gql `
mutation updateCompanyDetail($input: UpdateCompanyDetailInput!) {
  UpdateCompanyDetail(input: $input) {
    clientMutationId
  }
}
`;

export const UpdateAstuteDetails = gql `
mutation updateAstuteDetails($input: UpdateAstuteDetailsInput!) {
  UpdateAstuteDetails(input: $input) {
    clientMutationId
  }
}
`;


// WEBPACK FOOTER //
// ./src/queries/Profile/mutations.js